import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../Context/AuthContext";

const useInactivityTimer = ({ logoutTime = 15 * 60 * 1000 }) => {
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);

  const [warningVisible, setWarningVisible] = useState(false);
  const [inactiveMinutes, setInactiveMinutes] = useState(0);
  const timer = useRef(null);
  const warningTimer = useRef(null);
  const lastActivity = useRef(Date.now());
  const warningVisibleRef = useRef(false);
  const handleAutoLogout = async () => {
    setWarningVisible(false);

    await logout();

    navigate("/login", {
      state: {
        message: `${user?.name || "User"}, you have been logged out due to inactivity. Please log in again.`,
      },
    });
  };

  const resetTimers = () => {
    lastActivity.current = Date.now();
    clearTimeout(timer.current);
    clearTimeout(warningTimer.current);

    setWarningVisible(false);
    warningVisibleRef.current = false;
    setInactiveMinutes(0);

    timer.current = setTimeout(() => {
      setWarningVisible(true);
      warningVisibleRef.current = true;
      setInactiveMinutes(logoutTime / 60000);
      warningTimer.current = setTimeout(() => {
        handleAutoLogout();
      }, logoutTime);
    }, logoutTime);
  };
  const handleActivity = () => {
    if (warningVisibleRef.current) return;

    const now = Date.now();
    if (now - lastActivity.current > 1000) {
      resetTimers();
    }
  };

  useEffect(() => {
    if (!user) return;
    resetTimers();
    const activityEvents = [
      "mousemove",
      "keydown",
      "scroll",
      "click",
      "touchstart",
    ];
    activityEvents.forEach((event) =>
      window.addEventListener(event, handleActivity)
    );
    return () => {
      activityEvents.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
      clearTimeout(timer.current);
      clearTimeout(warningTimer.current);
    };
  }, [user]);
  return { warningVisible, inactiveMinutes, dismissWarning: resetTimers };
};
export default useInactivityTimer;
